
import { useEffect, useState } from "react"

export const useSubnetMappingsTable = (directTunnelData) => {

	const [subnetMappingsTable, setSubnetMappingsTable] = useState([])
	const [openMessageModal, setMessageModal] = useState(false)
	const [messageModalContent, setMessageModalContent] = useState("")

	const openMassageModalHandler = (isShowing, reason) => {
		if (!isShowing || !reason || reason === "N/A") {
			setMessageModal(false)
			return
		}
		setMessageModalContent(reason)
		setMessageModal(true)
	}

	const convertSubnetMappingsTable = (data) => {
		const result = []
		data.forEach((item) => {
			item.user_peer_col?.forEach((user_peer) => {
				result.push({
					id: user_peer.auth0_user_id,
					name: user_peer.user_name,
					email: user_peer.email,
					peers: user_peer.peers,
					subnet: item.network_mapping,
					status: item.status,
					mode: item.mode,
					activation: item.activated_time,
					deactivation: item.deactivated_time,
					reason: item.reason
				})
			})
		})

		setSubnetMappingsTable(result)
	}

	useEffect(() => {
		directTunnelData && convertSubnetMappingsTable(directTunnelData)
	}, [directTunnelData])

	return { subnetMappingsTable, openMessageModal, openMassageModalHandler, messageModalContent }
}
